/* ============================================================
   JINS × Heatherwick Studio — Landing Page JS
   Rebuilt from JP source — 2026-05-07
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('#jins-heatherwick')) return;

  // ----------------------------------------------------------
  // 1. Lenis smooth scroll
  //    Gives the page a weighted, fluid scroll feel matching JP
  //    Lenis is loaded as a theme asset on JINS US Shopify
  //    Desktop only — mobile uses native scroll
  // ----------------------------------------------------------
  function jtHwInitLenis() {
    if (typeof Lenis === 'undefined') return;
    if (window.innerWidth < 768) return;

    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  // ----------------------------------------------------------
  // 2. Liquid text distortion
  //    SVG feTurbulence + feDisplacementMap
  //    Triggers on hover (settle) + scroll velocity (ripple)
  //    Respects prefers-reduced-motion
  // ----------------------------------------------------------
  function jtHwInitLiquidText() {
    var turbulence   = document.getElementById('jt-hw-turbulence');
    var displacement = document.getElementById('jt-hw-displacement');
    var els = document.querySelectorAll('#jins-heatherwick .jt-hw-liquid');

    if (!turbulence || !displacement || !els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var raf = null;
    var currentScale = 0;
    var targetScale  = 0;
    var currentFreq  = 0;
    var animating    = false;

    function setFilter(scale, freq) {
      turbulence.setAttribute('baseFrequency', freq + ' ' + (freq * 0.6).toFixed(4));
      displacement.setAttribute('scale', scale.toFixed(2));
    }

    var raf = null;
    var currentScale = 0;
    var targetScale  = 0;
    var currentFreq  = 0;
    var targetFreq   = 0;
    var animating    = false;

    function animate() {
      currentScale += (targetScale - currentScale) * 0.08;
      currentFreq  += (targetFreq  - currentFreq)  * 0.08;
      setFilter(currentScale, currentFreq);

      var scaleDone = Math.abs(currentScale - targetScale) < 0.1;
      var freqDone  = Math.abs(currentFreq  - targetFreq)  < 0.0001;

      if (!scaleDone || !freqDone) {
        raf = requestAnimationFrame(animate);
      } else {
        setFilter(targetScale, targetFreq);
        animating = false;
      }
    }

    function startAnimate() {
      if (!animating) {
        animating = true;
        raf = requestAnimationFrame(animate);
      }
    }

    function trigger(intensity) {
      targetScale = Math.min(intensity * 28, 28);
      targetFreq  = intensity * 0.032;
      startAnimate();
    }

    function settle() {
      targetScale = 0;
      targetFreq  = 0;
      startAnimate();
    }

    els.forEach(function (el) {
      el.addEventListener('mouseenter', function () { trigger(0.75); });
      el.addEventListener('mouseleave', function () { settle(); });
      el.addEventListener('mousemove', function (e) {
        if (targetScale === 0) return; // only when active
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left)  / rect.width;
        var y = (e.clientY - rect.top)   / rect.height;
        // Map position to frequency variation
        var freqX = 0.015 + x * 0.025;
        var freqY = 0.015 + y * 0.025;
        turbulence.setAttribute('baseFrequency', freqX.toFixed(4) + ' ' + freqY.toFixed(4));
      });
    });

    var lastScrollY = window.scrollY;
    var scrollTick  = false;

    window.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        var delta = Math.abs(window.scrollY - lastScrollY);
        lastScrollY = window.scrollY;
        scrollTick  = false;
        if (delta > 8) trigger(Math.min(delta / 80, 1));
      });
    }, { passive: true });
  }

  // ----------------------------------------------------------
  // 2. Inview fade — IntersectionObserver
  // ----------------------------------------------------------
  function jtHwInitInview() {
    var els = document.querySelectorAll('#jins-heatherwick .jt-hw-inview');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  // ----------------------------------------------------------
  // 3. Anchor / hash scroll (Klaviyo deep-link support)
  // ----------------------------------------------------------
  function jtHwInitAnchorLinks() {
    var anchors = document.querySelectorAll(
      'a[href="#shop"], a[href="#story"], a[href="#plastic-frame"], a[href="#titanium-frame"]'
    );
    anchors.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var targetId = a.getAttribute('href').replace('#', '');
        var target   = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        var smoother = (typeof ScrollSmoother !== 'undefined') ? ScrollSmoother.get() : null;
        if (smoother) {
          smoother.scrollTo(target, true, 'top 80px');
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ----------------------------------------------------------
  // 4. Hash on load (Klaviyo deep-link support)
  // ----------------------------------------------------------
  function jtHwHandleHashOnLoad() {
    var hash = window.location.hash;
    if (!hash) return;
    var target = document.getElementById(hash.replace('#', ''));
    if (!target) return;
    setTimeout(function () {
      var smoother = (typeof ScrollSmoother !== 'undefined') ? ScrollSmoother.get() : null;
      if (smoother) {
        smoother.scrollTo(target, false, 'top 80px');
      } else {
        target.scrollIntoView({ block: 'start' });
      }
    }, 300);
  }

  // ----------------------------------------------------------
  // Init
  // ----------------------------------------------------------
  jtHwInitLenis();
  jtHwInitLiquidText();
  jtHwInitInview();
  jtHwInitAnchorLinks();
  jtHwHandleHashOnLoad();
});
